import React from "react";

const CalendarDay = ({ data }) => {
  // Fallback if values are missing
  const { pnl_range = "none", day_pnl = 0, date } = data;

  let bgColor = "bg-gray-100"; // Default

  // 📊 Color based on pnl_range
  switch (pnl_range.toLowerCase()) {
    case "very low loss":
      bgColor = "bg-red-200"; // light red
      break;
    case "loss":
      bgColor = "bg-red-400"; // darker red
      break;
    case "normal":
      bgColor = "bg-emerald-200"; // light green
      break;
    case "profit":
      bgColor = "bg-emerald-400"; // mid green
      break;
    case "high profit":
      bgColor = "bg-emerald-600"; // dark green
      break;
    default:
      bgColor = "bg-gray-100"; // no trade or unknown
  }

  const formattedValue = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Math.abs(day_pnl));

  return (
    <div
      className={`w-3 h-3 sm:w-4 sm:h-4 rounded-sm ${bgColor} transition-all hover:scale-125`}
      title={`${date}: ${day_pnl >= 0 ? "+" : "-"}${formattedValue}`}
    />
  );
};

export default CalendarDay;
